module.exports = __webpack_public_path__ + "static/media/appleDark.8ba69b04.svg";